import { render } from "./TooltipProvider.vue?vue&type=template&id=6ebfbad0"
import script from "./TooltipProvider.vue?vue&type=script&lang=js"
export * from "./TooltipProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__